import React from "react";
import useCurrentPage from "../../hooks/useCurrentPage";
import SEO from "../../components/SEO";

export default function Page404(props: { handlePage: any; }) {
  const { handlePage } = props;

  useCurrentPage(handlePage);

  return (
    <div className="not-found-page"  >
      <SEO
        title="Page Not Found"
        description="The page you are looking for does not exist."
      />
      <div className="content-404">
        <h1>Error 404</h1>
        <p> Oops! The resource you are looking can not be found.</p>
      </div>
    </div>
  );
}
